// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2aKW5","label":"SetPasswdForm_label__35x5a"};